function errorMsgHandle(msg) {
    console.log(msg)
    const searchString = "execution reverted:"
    const searchedIndex = msg.search(searchString)
    console.log("Search index", searchedIndex)
    if (searchedIndex === -1) {
        return null
    }
    const startIndex = msg.search(searchString) + searchString.length
    const endIndex = msg.slice(startIndex).indexOf('"') + startIndex
    return msg.substring(startIndex, endIndex)
}

export default {
    errorMsgHandle
}